// extracted by mini-css-extract-plugin
export default {"container":"ContentContainer_container__nRc9z"};